class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', (evt) => {
      if (evt.target.closest('[data-vl-close]')) {
        evt.preventDefault();
        this.close();
      }
    });
    this.setHeaderCartIconAccessibility();
    setTimeout(() => this.cleanupOrphanInsurance());
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const panel = document.getElementById('CartDrawer');
        if (!panel) return;
        const focusElement = panel.querySelector('.vl-close') || panel;
        trapFocus(panel, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement || !parsedState.sections || !parsedState.sections[section.id]) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.open();
      this.cleanupOrphanInsurance();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  /* Verzendverzekering: blijft er alleen nog de verzekering over in het mandje, dan halen we die weg. */
  cleanupOrphanInsurance() {
    const inner = this.querySelector('.vl-drawer__inner[data-orphan-insurance]');
    if (!inner) return;
    const id = inner.getAttribute('data-orphan-insurance');
    if (!id || id === '0') return;
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: String(id),
        quantity: 0,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((state) => {
        if (state.sections) {
          this.getSectionsToRender().forEach((section) => {
            const el = section.selector
              ? document.querySelector(section.selector)
              : document.getElementById(section.id);
            if (el && state.sections[section.id]) {
              el.innerHTML = this.getSectionInnerHTML(state.sections[section.id], section.selector);
            }
          });
        }
      })
      .catch(() => {});
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.vl-drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  onCartUpdate() {
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.querySelector('.vl-drawer__inner');
        const target = document.querySelector('.vl-drawer__inner');
        if (source && target) target.innerHTML = source.innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* Verzendverzekering aan/uit zetten (blok "Verzendverzekering") */
document.addEventListener('change', (event) => {
  const input = event.target.closest && event.target.closest('input[data-vl-insurance]');
  if (!input) return;

  const drawer = document.querySelector('cart-drawer');
  const id = String(input.getAttribute('data-vl-insurance'));
  const root = window.Shopify.routes.root;
  const base = { sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname };
  input.disabled = true;

  const request = input.checked
    ? fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], ...base }),
      })
    : fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: 0, ...base }),
      });

  request
    .then((response) => response.json())
    .then((state) => {
      if (state.status || !state.sections) throw new Error(state.description || 'cart error');
      drawer.getSectionsToRender().forEach((section) => {
        const el = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (el && state.sections[section.id]) {
          el.innerHTML = drawer.getSectionInnerHTML(state.sections[section.id], section.selector);
        }
      });
    })
    .catch(() => {
      input.checked = !input.checked;
      input.disabled = false;
    });
});

/* Themabewerker: de lade opent vanzelf zodra je de sectie of een blok selecteert */
if (window.Shopify && window.Shopify.designMode) {
  const openDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) setTimeout(() => drawer.open(), 50);
  };
  const closeDrawer = () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.close();
  };
  document.addEventListener('shopify:section:select', (e) => {
    if (e.detail.sectionId === 'cart-drawer') openDrawer();
  });
  document.addEventListener('shopify:section:load', (e) => {
    if (e.detail.sectionId === 'cart-drawer') openDrawer();
  });
  document.addEventListener('shopify:block:select', (e) => {
    if (e.detail.sectionId === 'cart-drawer') openDrawer();
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    if (e.detail.sectionId === 'cart-drawer') closeDrawer();
  });
}
